<script>
import * as m from '@app/paraglide/messages.js';
    let { event = $bindable({}) } = $props();

    function approveEvent() {
        if (event.approved === undefined){
            event.approved = true;
        } else if (event.approved === true){
            event.approved = false;
        } else if (event.approved === false){
            event.approved = undefined;
        }
    }

    </script>
<button
    id="approvalBtn-{event.id}"
    type="button"
    class="btn btn-link text-custom-medium {event.approved === false ? 'text-danger' : event.approved === true ? 'text-primary' : 'text-dark'}"
    onclick={()=> approveEvent()}
    aria-label={m.event_approval_aria_label()}>
    <i class="bi bi-{event.approved === false ? 'x' : 'check'}-circle" title={m.event_approval_title()}></i>
</button>

<style>
    button {
        padding : 2px;
        margin: 0;
    }
</style>